import React from "react";
import Button from "./Button";
import CloseIcon from "./icons/CloseIcon";

interface UserLocationInfoProps {
    userLocation: google.maps.LatLngLiteral;
    unsetUserLocationCallback: () => void;
}

const UserLocationInfo: React.FC<UserLocationInfoProps> = (props) => {

    return (

        <div className="blj-store-locator-user-location-info">

            <span className="blj-store-locator-user-location-info__address">
                {props.userLocation?.lat}, {props.userLocation?.lng}
            </span>

            <Button
                type="button"
                className="blj-store-locator-user-location-info__unset-btn"
                iconElement={<CloseIcon/>}
                onClick={props.unsetUserLocationCallback}
                variant={"icon"}
            />
        </div>

    );

}

export default UserLocationInfo;